import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import CallToAction from '../../components/CallToAction';
import '../ProjectPages/ProjectPage.css';

// Import images
import softwareHeroImage from '../../assets/images/software.jpg';

const MobileWebEN = () => {
  return (
    <div className="project-page">
      <Helmet>
        <title>Mobile and Web Applications | Digital Transformation Solutions - ProgenX 2025</title>
        <meta name="description" content="ProgenX mobile and web application development services. User-friendly, fast, and reliable applications for iPhone, Android, and web. Take your business to the digital world. Turkey's leading software development company." />
        <meta name="keywords" content="mobile app development, web app development, ios app, android app, digital transformation, software solutions, business process digitization, turkey software company, mobile app development" />
        <meta property="og:title" content="Mobile and Web Applications | ProgenX" />
        <meta property="og:description" content="We develop mobile and web applications that provide access to your customers from anywhere." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com/en/projects/mobile-web-applications" />
        <link rel="canonical" href="https://progenxacademy.com/en/projects/mobile-web-applications" />
        <link rel="alternate" hreflang="tr" href="https://progenxacademy.com/projeler/mobil-web-uygulamalari" />
        <link rel="alternate" hreflang="en" href="https://progenxacademy.com/en/projects/mobile-web-applications" />
      </Helmet>

      <Hero 
        title="Mobile and Web Applications" 
        backgroundImage={softwareHeroImage}
      />

      <div className="project-content">
        <div className="container">
          <section className="project-overview">
            <h2>Taking Your Business to the Digital World</h2>
            <p>
              Your customers are now everywhere. On their phones, tablets, computers. 
              As ProgenX, we ensure your business has a strong presence in this digital world. 
              By developing user-friendly, fast, and reliable mobile and web applications, 
              we help you offer the best experience to your customers.
            </p>
          </section>

          <section className="project-features">
            <h3>What Types of Applications Do We Develop?</h3>
            <div className="features-grid">
              <div className="feature-item">
                <h4>Mobile Applications</h4>
                <p>
                  We develop applications for iPhone and Android phones. Your customers 
                  can access your business from anywhere, anytime. We offer solutions that work on both iOS and 
                  Android with a single application.
                </p>
              </div>

              <div className="feature-item">
                <h4>Web Applications</h4>
                <p>
                  We develop web applications tailored to your business needs. From e-commerce 
                  sites to content management systems, from customer portals to business applications, 
                  we offer a wide range of solutions.
                </p>
              </div>

              <div className="feature-item">
                <h4>User Experience-Focused Design</h4>
                <p>
                  Our applications don't just work, they are also easy and enjoyable to use. 
                  By understanding what your customers want, we design according to their needs. 
                  This increases customer satisfaction.
                </p>
              </div>

              <div className="feature-item">
                <h4>Reliable and Fast Solutions</h4>
                <p>
                  Our applications load quickly, work securely, and grow as they grow. As your 
                  customer count increases, your application also grows. With performance tests, security checks 
                  and continuous updates, your application always stays in the best condition.
                </p>
              </div>
            </div>
          </section>

          <section className="project-benefits">
            <h3>What Do We Provide for Your Business?</h3>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h4>Access for Your Customers from Anywhere</h4>
                <p>Thanks to our mobile and web applications, your customers can access your business from 
                anywhere, anytime. This means more customers and more sales.</p>
              </div>
              <div className="benefit-item">
                <h4>Easy Use, Happy Customers</h4>
                <p>Our applications are easy to use. Your customers easily find what they want to do, 
                quickly complete their transactions. This increases satisfaction.</p>
              </div>
              <div className="benefit-item">
                <h4>Fast and Efficient Development</h4>
                <p>We bring your projects to life quickly. Your business starts to show its presence in the 
                digital world in a short time.</p>
              </div>
              <div className="benefit-item">
                <h4>We Are Always With You</h4>
                <p>We are with you even after your application is ready. Updates, maintenance, 
                support - we always ensure your application is in the best condition.</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <CallToAction 
        title="Be a Strong Presence in the Digital World"
        subtitle="Provide access to your customers from anywhere with mobile and web applications."
        buttonText="Get Project Quote" 
        buttonLink="/en/contact" 
      />
    </div>
  );
};

export default MobileWebEN;
